{
  "formesJuridiques": [
    { "code": "EI", "label": "Entreprise Individuelle", "categorie": "Entreprise individuelle" },
    { "code": "MICRO", "label": "Micro-entreprise", "categorie": "Entreprise individuelle" },
 
    { "code": "EURL", "label": "Entreprise Unipersonnelle à Responsabilité Limitée", "categorie": "Société commerciale" },
    { "code": "SARL", "label": "Société à Responsabilité Limitée", "categorie": "Société commerciale" },
    { "code": "SASU", "label": "Société par Actions Simplifiée Unipersonnelle", "categorie": "Société commerciale" },
    { "code": "SAS", "label": "Société par Actions Simplifiée", "categorie": "Société commerciale" },
    { "code": "SA", "label": "Société Anonyme", "categorie": "Société commerciale" },
    { "code": "SCA", "label": "Société en Commandite par Actions", "categorie": "Société commerciale" },
    { "code": "SNC", "label": "Société en Nom Collectif", "categorie": "Société commerciale" },
    { "code": "SCS", "label": "Société en Commandite Simple", "categorie": "Société commerciale" },
    { "code": "SE", "label": "Société Européenne", "categorie": "Société commerciale" },
 
    { "code": "SC", "label": "Société Civile", "categorie": "Société civile" },
    { "code": "SCI", "label": "Société Civile Immobilière", "categorie": "Société civile" },
    { "code": "SCCV", "label": "Société Civile de Construction-Vente", "categorie": "Société civile" },
    { "code": "SCPI", "label": "Société Civile de Placement Immobilier", "categorie": "Société civile" },
    { "code": "SCP", "label": "Société Civile Professionnelle", "categorie": "Société civile" },
    { "code": "SCM", "label": "Société Civile de Moyens", "categorie": "Société civile" },
 
    { "code": "EARL", "label": "Exploitation Agricole à Responsabilité Limitée", "categorie": "Société agricole" },
    { "code": "GAEC", "label": "Groupement Agricole d'Exploitation en Commun", "categorie": "Société agricole" },
    { "code": "SCEA", "label": "Société Civile d'Exploitation Agricole", "categorie": "Société agricole" },
    { "code": "SCA_AGRI", "label": "Société Coopérative Agricole", "categorie": "Société agricole" },
    { "code": "GFA", "label": "Groupement Foncier Agricole", "categorie": "Société agricole" },
 
    { "code": "SEL", "label": "Société d'Exercice Libéral", "categorie": "Exercice libéral" },
    { "code": "SELARL", "label": "SEL à Responsabilité Limitée", "categorie": "Exercice libéral" },
    { "code": "SELAS", "label": "SEL par Actions Simplifiée", "categorie": "Exercice libéral" },
    { "code": "SELASU", "label": "SEL par Actions Simplifiée Unipersonnelle", "categorie": "Exercice libéral" },
    { "code": "SELAFA", "label": "SEL à Forme Anonyme", "categorie": "Exercice libéral" },
    { "code": "SELCA", "label": "SEL en Commandite par Actions", "categorie": "Exercice libéral" },
    { "code": "SPFPL", "label": "Société de Participations Financières de Professions Libérales", "categorie": "Exercice libéral" },
 
    { "code": "SCOP", "label": "Société Coopérative de Production", "categorie": "Coopérative" },
    { "code": "SCIC", "label": "Société Coopérative d'Intérêt Collectif", "categorie": "Coopérative" },
    { "code": "CAE", "label": "Coopérative d'Activités et d'Emploi", "categorie": "Coopérative" },
    { "code": "COOP_ARTI", "label": "Coopérative artisanale", "categorie": "Coopérative" },
    { "code": "COOP_COMM", "label": "Coopérative de commerçants détaillants", "categorie": "Coopérative" },
 
    { "code": "GIE", "label": "Groupement d'Intérêt Économique", "categorie": "Groupement" },
    { "code": "GEIE", "label": "Groupement Européen d'Intérêt Économique", "categorie": "Groupement" },
 
    { "code": "ASSO", "label": "Association loi 1901", "categorie": "Sans but lucratif" },
    { "code": "ASSO_RUP", "label": "Association reconnue d'utilité publique", "categorie": "Sans but lucratif" },
    { "code": "FOND", "label": "Fondation", "categorie": "Sans but lucratif" },
    { "code": "FDD", "label": "Fonds de dotation", "categorie": "Sans but lucratif" },
    { "code": "MUT", "label": "Mutuelle", "categorie": "Sans but lucratif" },
 
    { "code": "SEP", "label": "Société en participation", "categorie": "Structure particulière" },
    { "code": "SCF", "label": "Société créée de fait", "categorie": "Structure particulière" },
    { "code": "SUCC", "label": "Succursale", "categorie": "Structure particulière" },
    { "code": "BUR_LIAISON", "label": "Bureau de liaison", "categorie": "Structure particulière" }
  ]
}